import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { INVOICES_SUMMARY } from 'api/query-keys.ts';
import type { InvoiceTotalsRes } from 'api/swagger';
import type { IInvoicesFilter } from 'shared/stores';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs.ts';
import type { IWithPagination } from 'types/api-query.ts';

interface IParams extends IWithPagination {
  search?: string;
  filters?: IInvoicesFilter;
}

export const useGetInvoicesSummary = (params?: IParams) => {
  const { search, filters } = params || {};

  const qs = new URLSearchParams();
  if (search) qs.set('filter[search]', search);
  if (filters) setFiltersToQs<IInvoicesFilter>(qs, filters);

  return useQuery<InvoiceTotalsRes>({
    queryKey: [INVOICES_SUMMARY, qs.toString()],
    queryFn: async () => {
      const { data } = await http.get<InvoiceTotalsRes>(`/v1/invoices/total?${qs.toString()}`);

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 10,
    cacheTime: 10,
  });
};
